import React from 'react'
import classnames from 'classnames'
import moment from 'moment'

import { ItemPriceHistory } from '../../../core/item-price-history'
import tableStyles from '../../styles/modules/table.module.scss'
import styles from '../../styles/modules/item-price-history/item-price-history.module.scss'

interface Props {
  isAdmin: boolean
  histories: ItemPriceHistory[]
}

const formatDateTime = (value?: string | null) => {
  if (!value) {
    return '-'
  }
  return moment(value).format('YYYY/MM/DD HH:mm')
}

const ItemPriceHistoryTable: React.FC<Props> = ({ histories, isAdmin }) => {
  if (histories.length === 0) {
    return <div className={styles.noData}>表示する価格履歴がありません</div>
  }

  return (
    <div
      className={classnames(
        tableStyles.wrapper,
        tableStyles.zebra,
        tableStyles.stocker
      )}
    >
      {isAdmin && (
        <p className={styles.description}>
          ※Mobileのコーヒー価格変更履歴を表示しています。KIOSK価格は変更履歴に反映されません。
        </p>
      )}
      <table className={classnames(tableStyles.container, styles.table)}>
        <thead>
          <tr className={tableStyles.row}>
            <th className={tableStyles.cell}>コーヒー</th>
            <th className={tableStyles.cell}>変更後価格</th>
            <th className={tableStyles.cell}>変更前価格</th>
            <th className={tableStyles.cell}>差分</th>
            <th className={tableStyles.cell}>適用開始</th>
            <th className={tableStyles.cell}>適用終了</th>
            <th className={tableStyles.cell}>編集者</th>
          </tr>
        </thead>
        <tbody>
          {histories.map(history => {
            const diff =
              history.previousPrice !== undefined &&
              history.previousPrice !== null
                ? history.price - history.previousPrice
                : 0
            const priceDiffClass =
              diff > 0
                ? styles.priceUp
                : diff < 0
                ? styles.priceDown
                : undefined

            return (
              <tr className={tableStyles.row} key={history.id}>
                <td
                  className={tableStyles.cell}
                >{`ID: ${history.itemId} ${history.itemName}`}</td>
                <td className={tableStyles.cell}>
                  {history.price.toLocaleString()}
                </td>
                <td className={tableStyles.cell}>
                  {history.previousPrice !== undefined &&
                  history.previousPrice !== null
                    ? history.previousPrice.toLocaleString()
                    : '-'}
                </td>
                <td className={classnames(tableStyles.cell, priceDiffClass)}>
                  {diff === 0
                    ? '±0'
                    : `${diff > 0 ? '+' : ''}${diff.toLocaleString()}`}
                </td>
                <td className={tableStyles.cell}>
                  {formatDateTime(history.startDate)}
                </td>
                <td className={tableStyles.cell}>
                  {history.endDate ? formatDateTime(history.endDate) : '適用中'}
                </td>
                <td className={tableStyles.cell}>{history.updatedBy ?? ''}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default ItemPriceHistoryTable
